import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getRegionAll } from '@/apis/common'
import store from '@/store'
export enum DeviceType {
  Mobile,
  Desktop,
}

export interface IAppState {
  device: DeviceType;
  projectList: any[];
  workerList: any[];
  deptList: any[];
  workerMap: any
  deptMap: any
  region: any[];
  sidebar: {
    opened: boolean;
    withoutAnimation: boolean;
  };
  messageStatus: number,
  globalRecord: {target: string, type: string, data: any}
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: false,
    withoutAnimation: false
  }
  public messageStatus = 0
  public globalRecord = {type: '', target: '', data: {}}
  public region = []
  public device = DeviceType.Desktop
  public projectList = [] as any []
  public workerList = [] as any []
  public deptList = [] as any []
  public workerMap: any = {}
  public deptMap: any = {}
  public containerType = 'mopower'
  @Action
  public async getRegionAll () {
    if (this.region.length) {
      return this.region
    }
    const res = await getRegionAll()
    if (res.success) {
      //fix 香港，澳门，台湾，特殊处理
      res.data[31].children = [{name: '', children: [{name: ''}]}]
      res.data[32].children = [{name: '', children: [{name: ''}]}]
      res.data[33].children = [{name: '', children: [{name: ''}]}]
      this.SET_COMMON_DATA({key: 'region', data: res.data})
    }
    return this.region
  }
  @Action
  public ToggleSideBar (withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar (withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }
  @Action
  public ChangeDept(list: any) {
    this.SET_DEPT(list)
  }
  @Action
  public ChangeProject(list: any) {
    this.SET_PROJECT(list)
  }
  @Action
  public ChangeWorkers(list: any) {
    this.SET_WORKERS(list)
  }
  @Action
  public ToggleDevice (device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }
  @Mutation
  public OPEN_MESSAGE () {
    this.messageStatus = Math.random()
  }
  @Mutation
  public SET_ENV (type) {
    // 设置环境，默认mp, 可能cep
    this.containerType = type
  }
  @Mutation
  public OPEN_RECORD (obj) {
    this.globalRecord = obj
  }
  @Mutation
  private SET_COMMON_DATA (data) {
    this[data.key] = Object.freeze(data.data)
  }
  @Mutation
  private SET_DEPT (list: any) {
    let obj = {}
    deepGetMap(list, obj)
    this.deptMap = Object.freeze(obj)
    this.deptList = list
  }
  @Mutation
  private SET_PROJECT (list: any) {
    this.projectList = list
  }
  @Mutation
  private UPDATE_PROJECT (row: any) {
    for (let item of this.projectList) {
      if (item.id === row.id) {
        item.state = row.state
      }
    }
  }
  @Mutation
  private SET_WORKERS (list: any) {
    // 包含已离职成员
    let obj = {}
    // 不包含已离职成员
    let arr: any = []
    list.forEach(({id, name, superiorId, headPic, isDelete, departmentIds}) => {
      let one = {id, name, superiorId, moType: 'member', headPic, departmentIds}
      if (isDelete === 0) {
        arr.push(one)
      }
      obj[id] = one
    })
    this.workerMap = Object.freeze(obj)
    this.workerList = arr || []
  }
  @Mutation
  private TOGGLE_SIDEBAR (withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    // if (this.sidebar.opened) {
    //   setSidebarStatus('opened')
    // } else {
    //   setSidebarStatus('closed')
    // }
  }

  @Mutation
  private CLOSE_SIDEBAR (withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    // setSidebarStatus('closed')
  }

  @Mutation
  private TOGGLE_DEVICE (device: DeviceType) {
    this.device = device
  }
}
function deepGetMap (list, obj) {
  list.forEach(({id, departmentName, parentId, children}) => {
    obj[id] = {id, name: departmentName, parentId, moType: 'dept'}
    if (children && children.length) {
      deepGetMap(children, obj)
    }
  })
}
export const AppModule = getModule(App)
